import { IconButton, Tooltip, Stack, Box } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import RemoveShoppingCartIcon from "@mui/icons-material/RemoveShoppingCart";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import { BaseChip } from "components/chips/base";
import { CART_MAX_QTY } from "constants";

export function CartButton({
 disabled,
 count = 0,
 onAdd,
 onRemove,
 onCheckout,
 hover,
 onHover,
}) {
 const iconColor = count > 0 ? "warning" : "inherit";

 const activeIcon = hover && !disabled ? (
  <AddShoppingCartIcon color={iconColor} />
 ) : (
  <ShoppingCartIcon color={iconColor} />
 );

 return (
  <Box
   onMouseEnter={() => onHover(true)}
   onMouseLeave={() => onHover(false)}
   sx={{
    display: "flex",
    alignItems: "center",
    flexDirection: "row-reverse",
    overflow: "hidden",
   }}
  >
   <Tooltip
    title={count >= CART_MAX_QTY ? `Limit reached (${CART_MAX_QTY})` : "Add to cart"}
    arrow
   >
    <BaseChip
     disabled={disabled}
     count={count}
     onClick={onAdd}
     icon={activeIcon}
     sx={{
      cursor: count >= CART_MAX_QTY ? "default" : "pointer",
      ml: 1,
      opacity: count >= CART_MAX_QTY ? 0.5 : 1,
     }}
     
    />
   </Tooltip>

   <Stack
    direction="row"
    spacing={1}
    sx={{
     display: hover && count > 0 ? "flex" : "none",
     transition: "all 0.3s ease",
     opacity: hover ? 1 : 0,
     transform: hover ? "translateX(0)" : "translateX(20px)",
     pointerEvents: hover ? "auto" : "none",
    }}
   >
    <Tooltip title="Checkout cart" arrow>
     <IconButton size="small" onClick={onCheckout}>
      <ShoppingCartCheckoutIcon fontSize="small" />
     </IconButton>
    </Tooltip>

    <Tooltip title="Remove from cart" arrow>
     <IconButton size="small" onClick={onRemove}>
      <RemoveShoppingCartIcon fontSize="small" />
     </IconButton>
    </Tooltip>
   </Stack>
  </Box>
 );
}
